import type { BootstrapableForm } from "types";
import type { useForm } from "hooks";
import type { Merchant, OnboardingApplication } from "features/ecommerce/types";

export const enum FormField {
    HasAgreedTermsConditions = 'hasAgreedTermsConditions'
};

export type OnboardingCompleteOnboaring = Pick<OnboardingApplication<Merchant.OnboardingApplication>, 'hasAgreedTermsConditions'>;

export type OnboardingCompleteOnboaringForm =
    & Omit<
        BootstrapableForm<OnboardingCompleteOnboaring, {}>,
        | 'initialValues'
    >
    & {
        readonly initialValues: OnboardingCompleteOnboaring;
    };

export type OnboardingCompleteOnboaringProps =
    & OnboardingCompleteOnboaringForm
    & ReturnType<typeof useForm<OnboardingCompleteOnboaring>>;
